import { useEffect } from "react";

import { useHealthCheckQuery } from "api/institutional/healthcheck_api";
import json from "./version.json";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

const RefreshSnack = ({
  oldVersion,
  newVersion,
}: {
  oldVersion: string;
  newVersion: string;
}) => {
  const { t } = useTranslation();
  const handleClick = () => {
    window.location.reload();
  };
  return (
    <div className="flex gap-2 items-center justify-center">
      {t(
        "A newer version is available ({{newVersion}}). Please refresh your browser to update.",
        { newVersion, oldVersion },
      )}
      <button className="font-bold underline" onClick={handleClick}>
        {t("Refresh")}
      </button>
    </div>
  );
};

export const HealthCheck = ({ children }: { children: any }) => {
  const { data: newVersion } = useHealthCheckQuery(undefined, {
    pollingInterval: 120000,
    skip: process.env.REACT_APP_ENV !== "production",
  });

  useEffect(() => {
    if (newVersion && json.version && newVersion !== json.version) {
      toast(<RefreshSnack newVersion={newVersion} oldVersion={json.version} />);
    }
  }, [newVersion]);

  return children;
};
